import React from 'react';
import { motion } from 'framer-motion';
import { Users, Award, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function AboutUs() {
  const {
    t,
    language
  } = useLanguage();
  return <section id="quienes-somos" className="py-16 md:py-24 bg-brand-bg relative overflow-hidden" data-id="element-18">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-cyan/5 blur-[120px] rounded-full pointer-events-none" data-id="element-19"></div>

      <div className="container mx-auto px-4 md:px-6 max-w-6xl relative z-10" data-id="element-20">
        <div className="text-center mb-12 md:mb-16" data-id="element-21">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-brand-purple/10 border border-brand-purple/30 text-brand-purple px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-semibold mb-4 md:mb-6" data-id="element-22">
            <Users className="w-3 h-3 md:w-4 md:h-4" data-id="element-23" />
            <span data-id="element-24">{t('about.badge')}</span>
          </motion.div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4" data-id="element-25">
            {t('about.title')} <span className="text-brand-cyan" data-id="element-26">Kinetic</span>
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto" data-id="element-27">
            {t('about.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-28">
          {/* Pierina */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-gradient-to-b from-brand-darker to-brand-bg border border-white/10 rounded-3xl p-6 md:p-8 relative group hover:border-brand-cyan/30 transition-colors" data-id="element-29">
            <div className="absolute -top-3 md:-top-4 left-6 md:left-8 bg-brand-cyan/20 p-2 md:p-3 rounded-full border border-brand-cyan/30" data-id="element-30">
              <Sparkles className="w-5 h-5 md:w-6 md:h-6 text-brand-cyan" data-id="element-31" />
            </div>

            <div className="mt-6 mb-4 md:mb-6" data-id="element-32">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-33">
                PIERINA DAVELOUIS FERRARI
              </h3>
              <p className="text-brand-cyan font-semibold mb-1 text-sm md:text-base" data-id="element-34">
                Founder & Digital Growth Strategist
              </p>
              <p className="text-gray-500 text-xs md:text-sm" data-id="element-35">
                Kinetic Growth Studio
              </p>
            </div>

            <div className="space-y-3 md:space-y-4 text-gray-300 leading-relaxed text-sm md:text-base" data-id="element-36">
              <p data-id="element-37">
                {language === 'es' ? 'Soy estratega de crecimiento digital con más de 12 años construyendo marcas, audiencias y sistemas de venta online.' : 'I am a digital growth strategist with over 12 years building brands, audiences and online sales systems.'}
              </p>
              <p data-id="element-38">
                {language === 'es' ? 'Hoy dirijo Kinetic Growth Studio con una misión simple: darte la presencia digital que tu negocio merece, rápido, profesional y sin excusas.' : 'Today I lead Kinetic Growth Studio with a simple mission: give you the digital presence your business deserves, fast, professional and without excuses.'}
              </p>
            </div>
          </motion.div>

          {/* Cristina */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gradient-to-b from-brand-darker to-brand-bg border border-white/10 rounded-3xl p-6 md:p-8 relative group hover:border-brand-purple/30 transition-colors" data-id="element-39">
            <div className="absolute -top-3 md:-top-4 left-6 md:left-8 bg-brand-purple/20 p-2 md:p-3 rounded-full border border-brand-purple/30" data-id="element-40">
              <Award className="w-5 h-5 md:w-6 md:h-6 text-brand-purple" data-id="element-41" />
            </div>

            <div className="mt-6 mb-4 md:mb-6" data-id="element-42">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-43">
                CRISTINA SANZ
              </h3>
              <p className="text-brand-purple font-semibold mb-1 text-sm md:text-base" data-id="element-44">
                Co-Partner & Creative Director
              </p>
              <p className="text-gray-500 text-xs md:text-sm" data-id="element-45">
                Kinetic Growth Studio
              </p>
            </div>

            <div className="space-y-3 md:space-y-4 text-gray-300 leading-relaxed text-sm md:text-base" data-id="element-46">
              <p data-id="element-47">
                {language === 'es' ? 'Diseñadora gráfica, Directora de arte digital & Co-Partner de Kinetic Growth Studio.' : 'Graphic designer, Digital art director & Co-Partner of Kinetic Growth Studio.'}
              </p>
              <p data-id="element-48">
                {language === 'es' ? 'Más de 25 años creando marcas e identidades visuales con alma. Fundadora de estudiocrispoppy y Mila Haru Editorial.' : 'Over 25 years creating brands and visual identities with soul. Founder of estudiocrispoppy and Mila Haru Editorial.'}
              </p>
              <p className="text-xs md:text-sm text-gray-400 border-t border-white/5 pt-3 md:pt-4" data-id="element-49">
                {language === 'es' ? 'Formada en Elisava · Rietveld Ámsterdam · Ogilvy & Mather' : 'Trained at Elisava · Rietveld Amsterdam · Ogilvy & Mather'}
              </p>
              <p className="text-brand-purple font-medium text-sm md:text-base" data-id="element-50">
                {language === 'es' ? 'Diseño estratégico para marcas que quieren crecer con identidad propia.' : 'Strategic design for brands that want to grow with their own identity.'}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}